<template>
    <el-drawer
        title="搜索并绑定 POIID"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="800px"
        @close="close"
        append-to-body
    >
        <div class="drawer-content" v-loading="dataLoading">
			<div class="MB20 color-blue">				 
				<p v-if="dataSite">场地名称: {{dataSite.siteName}} <span class="ML50">地址:{{dataSite.siteAddress}}</span></p>
			</div>
            <div class="page-filter-box">
                <el-row :gutter="20">
                    <el-col :span="12">
                       关键词：<el-input v-model="keyword" size="small" placeholder="关键词" class="MT10"></el-input>
                    </el-col>
                    <el-col :span="12">
						地址：<el-input v-model="address" size="small" placeholder="地址" class="MT10"></el-input>                        
                    </el-col>                    
                </el-row>
				<el-row :gutter="20">
					<el-col :span="12">
						省市：
						<el-cascader
						    v-model="areaCode"
						    :options="cityList"
						    filterable
						    :props="{label:'name',children:'cityList',value:'id', checkStrictly: true}"
						    size="small"
						    style="width:100%"
						    ref="cityCascader"
						    placeholder="选择省份/城市"                           
						    clearable
							class="MT10">
						</el-cascader>
					</el-col>
					<el-col :span="12">
						搜索范围(单位米)：
						<el-input v-model="radius" size="small" placeholder="搜索范围(单位米) " class="MT10"></el-input>
					</el-col>
					
				</el-row>
				<el-row>
					<el-col :span="8" class="page-filter-btns">
						
					    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
					    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
					</el-col>
				</el-row>
            </div>
			<div class="page-list-box">
			    <el-table
			        :data="dataList"
			        border
			        style="width: 100%"
			        v-loading="listLoading"
			        size="small"			        
					highlight-current-row					
			    >			        	        
			        <el-table-column prop="poiId" label="POI ID"></el-table-column>
			        <el-table-column prop="poiName" label="POI名称" min-width="120" show-overflow-tooltip></el-table-column>
					<el-table-column label="图片">					    
						<template slot-scope="scope">
						    <el-image v-if="scope.row.poiImage != 'null'" :src="scope.row.poiImage | coverImage(120)" fit="cover" :preview-src-list="[scope.row.poiImage]"></el-image>
							
						</template>
					</el-table-column>
			        <el-table-column prop="address" label="地址"  min-width="150" show-overflow-tooltip></el-table-column>			        
					<el-table-column fixed="right" label="操作">
						<template slot-scope="scope">
						    <el-button
						        v-if="$utils.have('/site/savePoiId')"
						        type="text"
						        size="small"
						        icon="el-icon-view"
						        @click="bind(scope.row)"
						        >绑定POIID</el-button>
						</template>
					</el-table-column>	
			    </el-table>
			</div>
        </div>
		<div class="drawer-footer">
		    <el-button @click="close">关闭</el-button>
		    
		</div> 
    </el-drawer>
</template>

<script>
import {fetchAllCity} from '@/assets/js/commonApi'

export default {
    props:{
		data: {
			type: Object,
			default: ()=> {}
		}
    },
    components:{},
    data(){
        return{
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
			listLoading:false,	
			
			dataSite:null,
			dataList: null,
			cityList: [],
			areaCode: [],
			city:[],			
			
			cityName:'',
			provinceName:'',
			keyword:'',
			address:'',
			radius:1000,
			siteId:'',
        }
    },
  
    methods:{      
        close() {           
			this.drawerShow = false;
			this.areaCode = [];
			this.dataList = null;
			this.keyword = ''
        },
        show() {
			this.dataSite = this.data
			
			this.areaCode = [parseInt(this.dataSite.siteProvinceCode),parseInt(this.dataSite.siteCityCode)]
			this.address = this.dataSite.siteAddress
			this.siteId = this.dataSite.siteId
			this.keyword = this.dataSite.siteName
            this.drawerShow = true;			
			
			this.getCityList()
			
        },
		//获取所有城市
		async getCityList(){
		    const res = await fetchAllCity({}).catch(() => {});
		    const{ state, result} = res.data;
		    if( state == 1 ){
		        this.cityList = result;	
		    }
			this.$nextTick(() => {
				this.getDataList()
			})
		},
		
		
		bind(data){
			
			const _url = "/site/bindRedBookletPoi";
			this.btnLoading = true;
			this.$request({
			    url: _url,
			    params: {
			        name:data.poiName,
					poiId:data.poiId,
					poiImage:data.poiImage != 'null' ? data.poiImage : '',
					siteId:this.siteId,
					activityId:this.dataSite.activityId
			    },
			    method: "post",
			})
			    .then((res) => {
			        const { state, msg } = res.data;
			        if (state == 1) {
			            this.$message.success("操作成功");
			            this.close();
						this.$emit('onUpdate');
			        } else {
			            this.$message.error(msg || "操作失败,请重试");
			        }
			    })
			    .catch(() => {
			        this.$message.error("操作失败,请重试");
			    })
			    .finally(() => {
			        this.btnLoading = false;
			    });  
		},
		//获取城市
		async getCityName(){
			const _nodes = this.$refs.cityCascader.getCheckedNodes()
		    if( _nodes && _nodes.length > 0 ){
				const _node = _nodes[_nodes.length - 1]
				if( _node.level == 1 ){
					this.provinceName = _node.label
					this.cityName = ''
				}else if( _node.level == 2 ){
					this.provinceName = _node.parent.label
					this.cityName = _node.label
				}
			}else{
				this.provinceName = ''
				this.cityName = ''
			}
		},
        //获取列表
        getDataList() {
			// this.getCityList()
			this.getCityName()
			if( this.keyword == ''){
				return  this.$message.error("先请输入关键词");
			}
            this.listLoading = true;
            this.$request({
                url: "/site/searchRedBookletPoi",
                method: "POST",
                params: {
					address:this.address,
					cityName:this.cityName,
					keyWord:this.keyword,
					provinceName:this.provinceName,
					radius:this.radius,
					siteId:this.siteId
				},
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {                       
                        this.dataList = result || [];
						
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //搜索
        search() {            
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.show()
        },
        
    }
}
</script>

<style lang="scss" scoped>
.ML50{
	margin-left: 50px;
}
.preview-box{
    text-align: center;
    .el-image{
        max-width: 100%;
    }
}
.upload-btn {
    height: 36px;
    line-height: 36px;
    border-radius: 4px;
    text-align: center;
    position: relative;
    background: $--color-theme;
    overflow: hidden;
    .upload-bar{
        ::v-deep .el-upload{
            width: 100%;
        }
    }
    .el-button {
        width: 100%;
        background: none;
        border: 0;
    }
    .progress-bar {
        display: block;
        height: 100%;
        color: #ffffff;
        span {
            position: absolute;
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
        }
        .progress {
            height: 100%;
            background: #67c23a;
            transition: width 0.6s ease-out;
        }
    }
}

</style>